import styles from './styles.module.css';
import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';

import aboutArImg from "src/assets/images/home/about/about_ar.webp";
import aboutEnImg from "src/assets/images/home/about/about_en.webp";
import aboutItImg from "src/assets/images/home/about/about_it.webp";


import { isRTL } from 'src/utils/global';
import CustomButton from 'src/components/customButton/CustomButton';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';

const About = () => {
    const { t, i18n } = useTranslation("home");

    // Select image based on current language
    const getAboutImage = () => {
        switch (i18n.language) {
            case "ar":
                return aboutArImg;
            case "it":
                return aboutItImg;
            default:
                return aboutEnImg;
        }
    };

    return (
        <Element data-aos="fade-up" name="aboutUs" className={`${styles.about} ${isRTL() && styles.rtl}`}>
            <div className='container'>
                <div className={'row'}>
                    <div className='col-lg-5 d-flex align-items-center'>
                        <div className={styles.img__con}>
                            <img
                                src={getAboutImage()}
                                alt={t("about.title")}
                                width={460}
                                height={240}
                                loading='lazy'
                            />
                        </div>
                    </div>
                    <div className='col-lg-7 my-auto'>
                        <div className={styles.subTitle}>
                            {t("about.sub_title")}
                        </div>
                        <h2 className={styles.title}>
                            {t("about.title")}
                        </h2>
                        <p className={`${styles.about__text} global-p`}>
                            {t("about.content")}
                        </p>
                        <CustomButton
                            text={
                                <>
                                    {t("about.btn")}
                                    {i18n.language.includes("ar") ? (
                                        <FaArrowLeft color="#fff" />
                                    ) : (
                                        <FaArrowRight color="#fff" />
                                    )}
                                </>
                            }
                            className={styles.about_btn}
                            theme="primary"
                            to='/about'
                        />
                    </div>
                </div>
            </div>
        </Element>
    )
}

export default About;
